const Path = require( '@leverege/path' )

const SPLIT = /[/.]/

/**
* This will return a function (model, value) that makes a shallow copy of 
* of the model and sets the value on model[key]. 
* @param {string} key the name of the attribute that we are making a copy of
* @param {object} [options]
* @param {function} [options.validate] ( model, key, value ) function is called to
* allow it to reject the change by throwing an error. If a value other than undefined
* is returned, this value will be set in the model. This is useful for turning values
* like an empty string into null. 
**/
function createSetValue( key, options ) {
  if ( key.includes( '/' ) || key.includes( '.' ) ) {
    const path = Path( key.split( SPLIT ) )
    return ( model, v ) => {
      let value = v
      if ( options && options.validate ) {
        const mutate = options.validate( model, key, value )
        if ( mutate !== undefined ) {
          value = mutate
        }
      }
      const cValue = path.get( model )
      if ( value === cValue ) {
        return model
      }
      return path.copy( model, value )
    }
  }

  return ( model, v ) => {
    let value = v
    if ( options && options.validate ) {
      const mutate = options.validate( model, key, value )
      if ( mutate !== undefined ) {
        value = mutate
      }
    }
    if ( value === model[key] ) {
      return model
    }
    const c = { ...model }
    c[key] = value
    return c
  }
}

function createGetValue( key, options ) {
  if ( key.includes( '/' ) || key.includes( '.' ) ) {
    const path = Path( key.split( SPLIT ) )
    return ( model ) => {
      const val = path.get( model, undefined )
      if ( val === undefined ) {
        return options && options.defaultValue
      }
      return val
    }
  }

  return ( model ) => {
    if ( model[key] === undefined ) {
      return options && options.defaultValue
    }
    return model[key]
  }
}

function createAllValue( key, name, setOpts, getOpts ) {
  if ( name == null ) {
    // eslint-disable-next-line no-param-reassign
    name = `${key[0].toUpperCase() + key.substring( 1 )}`
  } else {
    // eslint-disable-next-line no-param-reassign
    name = `${name[0].toUpperCase() + name.substring( 1 )}`

  }
  return {
    [`set${name}`] : createSetValue( key, setOpts ),
    [`get${name}`] : createGetValue( key, getOpts )
  }
}
 
exports.createSetValue = createSetValue
exports.createGetValue = createGetValue
exports.createAllValue = createAllValue
